import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

const base = createCrudStore("balanceados/reservas");

const reservasGranoStore = {
  ...base,

  state: {
    ...base.state,
    resumen: null,
    movimientos: [],
  },

  getters: {
    ...base.getters,
    reservas(state) {
      return Array.isArray(state["balanceados/reservas"])
        ? state["balanceados/reservas"]
        : [];
    },
    reservasConStock(state, getters) {
      return getters.reservas.filter((r) => r.stock_actual > 0);
    },
    resumen: (state) => state.resumen,
    movimientos: (state) => state.movimientos,
  },

  mutations: {
    ...base.mutations,
    setResumen(state, data) {
      state.resumen = data;
    },
    setMovimientos(state, data) {
      state.movimientos = data;
    },
  },

  actions: {
    ...base.actions,

    getReservas: base.actions.getAllStates,

    async postReserva({ dispatch }, payload) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.create("balanceados/reservas", payload),
        onSuccessCallback: (commit, data) => commit("addItem", data),
        errorMessage: "Error al crear reserva",
      });
    },

    async patchReserva({ dispatch }, { id, payload }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.update("balanceados/reservas", id, payload),
        onSuccessCallback: (commit, data) => commit("updateItem", data),
        errorMessage: "Error al editar reserva",
      });
    },

    async deleteReserva({ dispatch }, id) {
      return dispatch("executeApiCall", {
        apiCallFunction: () => apiService.delete("balanceados/reservas", id),
        onSuccessCallback: (commit) => commit("removeItem", id),
        errorMessage: "Error al eliminar reserva",
      });
    },

    async getResumen({ dispatch }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom("/balanceados/reservas/resumen"),
        onSuccessCallback: (commit, data) => commit("setResumen", data),
        errorMessage: "Error al obtener resumen de reservas",
      });
    },

    async postMovimiento({ dispatch }, { reservaId, payload }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom(
            `/balanceados/reservas/${reservaId}/movimientos`,
            payload
          ),
        onSuccessCallback: async () => {
          await dispatch("getReservas");
        },
        errorMessage: "Error al registrar movimiento",
      });
    },

    async getMovimientos({ dispatch }, reservaId) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom(
            `/balanceados/reservas/${reservaId}/movimientos`
          ),
        onSuccessCallback: (commit, data) => commit("setMovimientos", data),
        errorMessage: "Error al obtener movimientos",
      });
    },

    // ── Seguros reserva ──
    async getSegurosReserva(_, reservaId) {
      const res = await apiService.getCustom(
        `/balanceados/reservas/${reservaId}/seguros`
      );
      return res;
    },

    async postSeguroReserva(_, { reservaId, seguro }) {
      const res = await apiService.postCustom(
        `/balanceados/reservas/${reservaId}/seguros`,
        seguro
      );
      return res;
    },

    async putSeguroReserva(_, { reservaId, seguroId, seguro }) {
      const res = await apiService.putCustom(
        `/balanceados/reservas/${reservaId}/seguros/${seguroId}`,
        seguro
      );
      return res;
    },

    async deleteSeguroReserva(_, { reservaId, seguroId }) {
      await apiService.deleteCustom(
        `/balanceados/reservas/${reservaId}/seguros/${seguroId}`
      );
    },
  },
};

export default {
  namespaced: true,
  ...reservasGranoStore,
};
